const getImageModalOpen = () => {};

export default getImageModalOpen;

